import React, { memo } from 'react';

import type { UseTableProps } from '@sravni/react-design-system/lib/Table';
import { TableView, useTable } from '@sravni/react-design-system/lib/Table';
import { useStyles } from '@sravni/react-utils';

import { TBody } from '@components/RatingTable/components/Table/components/TBody/TBody';

import type { OrganizationRatingItem, ProductRatingItem } from '../../../../types/rating';

import styles from './table.module.scss';

type TProps = {
  config: UseTableProps<OrganizationRatingItem | ProductRatingItem>;

  setProduct: (product: any) => void;
  setProductPopupVisibility: { on: () => void; off: () => void; toggle: () => void };
  canShowProductPopup: boolean;
};

export const Table = memo<TProps>(({ config, setProduct, setProductPopupVisibility, canShowProductPopup }) => {
  const cx = useStyles(styles);
  const table = useTable(config);

  return (
    <div className={cx('tableWrapper')}>
      <TableView className={cx('table')}>
        <TableView.Thead className={cx('thead')}>
          {table.getHeaderGroups().map((headerGroup) => (
            <tr key={`${headerGroup.id}-headerGroup`}>
              {headerGroup.headers.map((header) => {
                const isCanSort = header.column.getCanSort();

                return (
                  <TableView.Head
                    key={`${header.id}-header`}
                    header={header}
                    className={cx('header', { rightHeader: header.index !== 1, headerWithSort: isCanSort })}
                    size={16}
                  />
                );
              })}
            </tr>
          ))}
        </TableView.Thead>
        <TBody
          rows={table.getSortedRowModel().rows}
          setProduct={setProduct}
          setProductPopupVisibility={setProductPopupVisibility}
          canShowProductPopup={canShowProductPopup}
        />
      </TableView>
    </div>
  );
});
